import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
  static targets = ['button', 'close'];

  static values = {
    open: Boolean,
  };

  openValueChanged() {
    this.buttonTarget.setAttribute('aria-expanded', this.openValue);

    if (this.hasCloseTarget) {
      this.closeTarget.setAttribute('aria-expanded', this.openValue);
    }
  }

  toggle() {
    this.openValue = !this.openValue;
  }

  close() {
    this.openValue = false;
  }
}